export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;
export const CNPJ_BASE_LENGTH = 12;
export const CNPJ_CHECK_DIGITS_LENGTH = 2;

/** ngx-mask: A = alphanumeric, 0 = digit */
export const CNPJ_MASK_NGX = 'AA.AAA.AAA/AAAA-00';
export const CPF_MASK_NGX = '000.000.000-00';
export const CPF_CNPJ_MASK_NGX = `${CPF_MASK_NGX}||${CNPJ_MASK_NGX}`;

/** @ngneat/input-mask: * = alphanumeric, 9 = digit */
export const CNPJ_MASK_INPUT_MASK = '**.***.***/****-99';
export const CPF_MASK_INPUT_MASK = '999.999.999-99';
export const CPF_CNPJ_MASK_INPUT_MASK = [CPF_MASK_INPUT_MASK, CNPJ_MASK_INPUT_MASK];

export const CNPJ_UNMASKED_PATTERN = /^[0-9A-Z]{12}[0-9]{2}$/;
